<script lang="ts" setup>
import { computed, ref, type Component } from "vue";
import type { TableColumn, AlertsStore } from "./types"
import isUndefined from "lodash/isUndefined";
// import SrGroupDataTable from "../SrGroupDataTable.vue";
import SrDataTable from "./../tables/SrDataTable.vue";

const props = defineProps<{
  store: AlertsStore
  alerts?: object[]
  paginator?: boolean
  lazy?: boolean
  pageSize?: number
  fakeRowsCount: number
  columns: Array<TableColumn>
  formattingRules: Record<string, (v: string, ctx?: Record<string, unknown>, field_name?: string) => string>
  skeletonHeight?: string
  loading?: boolean
  colFull?: boolean
  groupSortField?: string,
  groupSortOrder?: number,
  tableComponent?: Component
  tableComponentProps?: Record<string, any> // eslint-disable-line
}>()

// let updateRowsInterval = 0
const skeletonHeight = computed(() => props.skeletonHeight ?? "18px")
// const fakeRows = Array.from({ length: props.fakeRowsCount }, () => null);
const currentPage = ref(0)
const initialization = ref(true)
const sortField = ref()
const sortOrder = ref()
const totalRecords = ref(0)
const loading = computed(() => props.store.loading || props.loading)
const colFull = computed(() => isUndefined(props.colFull) ? true : props.colFull)

const tableRows = computed(() => {
  return (props.alerts ?? props.store.alerts)
})

const setInitializationState = (v: boolean) => {
  initialization.value = v
}

const setSort = (field: string, order: number) => {
  sortField.value = field
  sortOrder.value = order
  if (props.store.sort) {
    props.store.sort(field, order)
  }
}

const refresh = async () => {
  const store = props.store
  await store.fetch(currentPage.value, { keepState: true })
}

const onPage = async (
  page_num: number | null = 0,
  defaultSortField: string | null = null,
  defaultSortOrder: number | null = null,
  keepState: boolean = false
) => {
  if (!props.lazy) {
    return
  }

  if (page_num == null) {
    page_num = 0
  }

  const store = props.store

  if (store.sort) {
    const newSortField = defaultSortField ?? sortField.value
    const newSortOrder = defaultSortOrder ?? sortOrder.value
    store.sort(newSortField, newSortOrder)
    sortField.value = newSortField
    sortOrder.value = newSortOrder
  }

  currentPage.value = page_num

  await store.fetch(page_num, { keepState: keepState })
  initialization.value = false

  if (props.store.pageSize && props.store.pages) {
    totalRecords.value = props.store.pageSize * props.store.pages
  } else {
    if (props.store.alerts) {
      totalRecords.value = props.store.alerts.length
    }
  }
}

defineExpose({ refresh, onPage, setSort, sortField, sortOrder, setInitializationState })
</script>

<template>
  <!-- Для отображения данных используется свой компонент SrDataTable -->
  <component :is="tableComponent ?? SrDataTable" v-model:sortField="sortField" v-model:sortOrder="sortOrder"
    size="small" :totalRecords="totalRecords" :lazy="props.lazy" :value="tableRows" @sort="onPage()"
    :paginator="props.paginator" :skeletonHeight="skeletonHeight" :rows="props.pageSize ?? props.store.pageSize"
    :columns="props.columns" @page="onPage" :loading="loading" :formattingRules="props.formattingRules"
    :colFull="colFull" v-bind="tableComponentProps ?? {}" :fake-rows-count="fakeRowsCount"
    :groupSortField="groupSortField" :groupSortOrder="groupSortOrder">
    <template #empty>
      <div class="text-center" style="z-index: 0">{{ $t('emptyMessage') }}</div>
    </template>
  </component>
</template>
